import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const OfficeIndex = () => import('../views/office/index.vue')
const InviteLandingIndex = () => import('../views/inviteLanding/index.vue')
const PolicyIndex = () => import('../views/policy/index.vue')

export default new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/office' },
    { path: '/office', component: OfficeIndex },
    { path: '/invite', component: InviteLandingIndex },
    { path: '/policy/:doc', component: PolicyIndex }
  ]
})
